import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faList,
  faPlane,
  faSuitcase,
} from '@fortawesome/free-solid-svg-icons';
import { FlightSearch } from 'ts/flight/interfaces/FlightSearch';
import FlightPairsTicket from './FlightPairsTicket';
import RulesContent from '../Book/RulesContent';
import FlightPairsBaggage from './FlightPairsBaggage';
import FlightPairsFlex from './FlightPairsFlex';
import Tabs from 'components/ui/Tabs/Tabs';

interface FlightPairsTabsProps {
  flight: FlightSearch;
  sessionStorageKey: string;
  soloMode?: boolean;
}

const FlightPairsTabs: FC<FlightPairsTabsProps> = ({ ...props }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    setActiveTab(1);
  }, [props.flight]);

  return (
    <div className="flex-one flex-column " style={{ maxWidth: '100%' }}>
      <div className="mt-5"></div>
      <Tabs
        label={t('details')}
        className="hotels-tabs"
        value={String(activeTab)}
        onValueChange={(v) => setActiveTab(Number(v))}
        items={[
          {
            value: '1',
            label: (
              <>
                <FontAwesomeIcon
                  size="xs"
                  icon={faPlane as any}
                  className="mr-5"
                  style={{ transform: 'rotate(-45deg)' }}
                />
                {t('details')}
              </>
            ),
          },
          {
            value: '2',
            label: (
              <>
                <FontAwesomeIcon
                  size="sm"
                  icon={faExclamationTriangle as any}
                  color="#a4c3a3"
                  className="mr-5"
                />
                {t('rules')}
              </>
            ),
          },
          {
            value: '3',
            label: (
              <>
                <FontAwesomeIcon size="sm" icon={faSuitcase as any} className="mr-5" />
                ++
              </>
            ),
          },
          {
            value: '4',
            disabled: !props.flight.fareFamilyInfo?.length,
            label: (
              <>
                <FontAwesomeIcon size="sm" icon={faList as any} className="mr-5" />
                ++
              </>
            ),
          },
        ]}
      />

      <div className="fl-pair-details">
        {activeTab === 1 && (
          <FlightPairsTicket
            flight={props.flight}
            sessionStorageKey={props.sessionStorageKey}
            soloMode={props.soloMode}
          />
        )}

        {activeTab === 2 && (
          <RulesContent
            flightId={props.flight.id}
            searchToken={sessionStorage.getItem(props.sessionStorageKey) || ''}
          />
        )}
        {activeTab === 3 && (
          <FlightPairsBaggage flight={props.flight} sessionStorageKey={props.sessionStorageKey} />
        )}
        {activeTab === 4 && (
          <FlightPairsFlex flight={props.flight} sessionStorageKey={props.sessionStorageKey} />
        )}
      </div>
    </div>
  );
};

export default FlightPairsTabs;
